import { VocationIndustry } from "./vocationIndustry";

export const VOCATION_HEALTH_SUBINDUSTRY = {
  HEALTH_ADMINISTRATIVE: "HEALTH_ADMINISTRATIVE",
  HEALTH_CLINICAL_SUPPORT: "HEALTH_CLINICAL_SUPPORT",
  HEALTH_DIRECT_PATIENT_CARE: "HEALTH_DIRECT_PATIENT_CARE",
  HEALTH_MENTAL_AND_PHYSICAL_WELLNESS: "HEALTH_MENTAL_AND_PHYSICAL_WELLNESS",
} as const;

export type VocationHealthSubindustry =
  (typeof VOCATION_HEALTH_SUBINDUSTRY)[keyof typeof VOCATION_HEALTH_SUBINDUSTRY];

const vocationHealthSubindustryFriendlyMap: Record<VocationHealthSubindustry, string> = {
  HEALTH_ADMINISTRATIVE: "Administrative",
  HEALTH_CLINICAL_SUPPORT: "Clinical support",
  HEALTH_DIRECT_PATIENT_CARE: "Direct patient care",
  HEALTH_MENTAL_AND_PHYSICAL_WELLNESS: "Mental and physical wellness",
};

export const VOCATION_BUSINESS_SUBINDUSTRY = {
  BUSINESS_ADMINISTRATION: "BUSINESS_ADMINISTRATION",
  BUSINESS_EDUCATION: "BUSINESS_EDUCATION",
  BUSINESS_FINANCE_AND_ACCOUNTING: "BUSINESS_FINANCE_AND_ACCOUNTING",
  BUSINESS_LEGAL: "BUSINESS_LEGAL",
  BUSINESS_MARKETING_AND_DESIGN: "BUSINESS_MARKETING_AND_DESIGN",
} as const;

export type VocationBusinessSubindustry =
  (typeof VOCATION_BUSINESS_SUBINDUSTRY)[keyof typeof VOCATION_BUSINESS_SUBINDUSTRY];

const vocationBusinessSubindustryFriendlyMap: Record<VocationBusinessSubindustry, string> = {
  BUSINESS_ADMINISTRATION: "Administration",
  BUSINESS_EDUCATION: "Education",
  BUSINESS_FINANCE_AND_ACCOUNTING: "Finance and accounting",
  BUSINESS_LEGAL: "Legal",
  BUSINESS_MARKETING_AND_DESIGN: "Marketing and design",
};

export const VOCATION_TECHNOLOGY_SUBINDUSTRY = {
  TECHNOLOGY_CYBERSECURITY_AND_IT: "TECHNOLOGY_CYBERSECURITY_AND_IT",
  TECHNOLOGY_ENGINEERING: "TECHNOLOGY_ENGINEERING",
  TECHNOLOGY_PRODUCT_DEVELOPMENT: "TECHNOLOGY_PRODUCT_DEVELOPMENT",
  TECHNOLOGY_SOFTWARE_AND_ANALYTICS: "TECHNOLOGY_SOFTWARE_AND_ANALYTICS",
} as const;

export type VocationTechnologySubindustry =
  (typeof VOCATION_TECHNOLOGY_SUBINDUSTRY)[keyof typeof VOCATION_TECHNOLOGY_SUBINDUSTRY];

const vocationTechnologySubindustryFriendlyMap: Record<VocationTechnologySubindustry, string> = {
  TECHNOLOGY_CYBERSECURITY_AND_IT: "Cybersecurity and IT",
  TECHNOLOGY_ENGINEERING: "Engineering",
  TECHNOLOGY_PRODUCT_DEVELOPMENT: "Product development",
  TECHNOLOGY_SOFTWARE_AND_ANALYTICS: "Software and analytics",
};

export const VOCATION_TRADE_SUBINDUSTRY = {
  TRADE_COSMETOLOGY: "TRADE_COSMETOLOGY",
  TRADE_CULINARY: "TRADE_CULINARY",
  TRADE_TECHNICIAN: "TRADE_TECHNICIAN",
  TRADE_TRADES: "TRADE_TRADES",
  TRADE_TRANSPORTATION: "TRADE_TRANSPORTATION",
} as const;

export type VocationTradeSubindustry =
  (typeof VOCATION_TRADE_SUBINDUSTRY)[keyof typeof VOCATION_TRADE_SUBINDUSTRY];

const vocationTradeSubindustryFriendlyMap: Record<VocationTradeSubindustry, string> = {
  TRADE_COSMETOLOGY: "Cosmetology",
  TRADE_CULINARY: "Culinary",
  TRADE_TECHNICIAN: "Technician",
  TRADE_TRADES: "Trades",
  TRADE_TRANSPORTATION: "Transportation",
};

export const VOCATION_SUBINDUSTRY = {
  ...VOCATION_HEALTH_SUBINDUSTRY,
  ...VOCATION_BUSINESS_SUBINDUSTRY,
  ...VOCATION_TECHNOLOGY_SUBINDUSTRY,
  ...VOCATION_TRADE_SUBINDUSTRY,
} as const;

export type VocationSubindustry = (typeof VOCATION_SUBINDUSTRY)[keyof typeof VOCATION_SUBINDUSTRY];

export const vocationSubindustryFriendlyMap: Record<VocationSubindustry, string> = {
  ...vocationHealthSubindustryFriendlyMap,
  ...vocationBusinessSubindustryFriendlyMap,
  ...vocationTechnologySubindustryFriendlyMap,
  ...vocationTradeSubindustryFriendlyMap,
};

export const IndustryToSubindustryMap: Record<VocationIndustry, VocationSubindustry[]> = {
  AGRICULTURE: [],
  BUSINESS_AND_OFFICE: Object.values(VOCATION_BUSINESS_SUBINDUSTRY),
  MARKETING_AND_DISTRIBUTION: [],
  HEALTH: Object.values(VOCATION_HEALTH_SUBINDUSTRY),
  OCCUPATION_AND_ECONOMICS: [],
  TRADE_AND_INDUSTRY: Object.values(VOCATION_TRADE_SUBINDUSTRY),
  TECHNICAL_AND_COMMUNICATIONS: Object.values(VOCATION_TECHNOLOGY_SUBINDUSTRY),
  OTHER: [],
};
